module.exports = __webpack_public_path__ + "img/bg3.fbc8ca9b.png";